import demosAPI from "@/api/demos";

const getDefaultState = () => ({
  demosListConfig: {
    pagination: {
      page: null,
      limit: null,
      sort: null,
      ordering: null,
    },
    queryParams: {},
    paginationCount: 0,
  },

  demosList: [],
  fetchDemosListLoading: false,
  fetchDemosListError: false,
  fetchDemosListErrorResponse: null,

  demoProduct: {
    status: null,
    username: null,
    lead_id: null,
    number: {},
    last_changed: null,
    instance: null,
    number_id: null,
    supplier: null,
    password: null,
    creation_timestamp: null,
    id: null,
  },

  fetchDemoByIdLoading: false,
  fetchDemoByIdError: false,
  fetchDemoByIdErrorResponse: null,
});

const state = getDefaultState();

const mutations = {
  FETCH_DEMOS_LIST_BEGIN(state) {
    state.fetchDemosListLoading = true;
    state.fetchDemosListError = false;
    state.fetchDemosListErrorResponse = null;
  },
  FETCH_DEMOS_LIST_SUCCESS(state, payload) {
    state.demosList = payload.data;
    state.demosListConfig.paginationCount = payload['pagination-count'];
    state.fetchDemosListLoading = false;
  },
  FETCH_DEMOS_LIST_ERROR(state, err) {
    state.fetchDemosListLoading = false;
    state.fetchDemosListError = true;
    state.fetchDemosListErrorResponse = err;
  },

  UPDATE_DEMOS_LIST_CONFIG_FILTERS(state) {
    state.demosListConfig.pagination.page = 1;
  },

  UPDATE_DEMOS_LIST_CONFIG_PAGINATION(state, { pagination, queryParams }) {
    const queryKeyMap = {};

    if(pagination) {
      for(let param in state.demosListConfig.pagination) {
        if(pagination[param]) {
          state.demosListConfig.pagination[param] = pagination[param];
        }
      }
    }

    if(queryParams) {
      for(let param in state.demosListConfig.queryParams) {
        if(queryParams.hasOwnProperty(param)) {
          if(queryKeyMap[param].includes("__in") && typeof queryParams[param] === "string") {
            state.demosListConfig.queryParams[param] = queryParams[param].split(",");
          } else {
            state.demosListConfig.queryParams[param] = queryParams[param];
          }
        }
      }
    }
  },

  FETCH_DEMO_BY_ID_BEGIN(state) {
    state.fetchDemoByIdLoading = true;
    state.fetchDemoByIdError = false;
    state.fetchDemoByIdErrorResponse = null;
  },
  FETCH_DEMO_BY_ID_SUCCESS(state, payload) {
    state.fetchDemoByIdLoading = false;
    state.demoProduct = payload;
  },
  FETCH_DEMO_BY_ID_ERROR(state, err) {
    state.fetchDemoByIdLoading = false;
    state.fetchDemoByIdError = true;
    state.fetchDemoByIdErrorResponse = err;
  },

  RESET_DEMOS_STORE(state) {
    Object.assign(state, getDefaultState());
  },
};

const actions = {
  async fetchDemosList({state, commit}) {
    commit('FETCH_DEMOS_LIST_BEGIN'); 
    
    const url = new URL(window.location);
    const query = {};

    Object.entries({ ...state.demosListConfig.pagination, ...state.demosListConfig.queryParams }).forEach(([k,v]) => {
      if(v && !Array.isArray(v) || (Array.isArray(v) && v.length)) {
        query[k] = v;
        url.searchParams.set(k,v);
      } else {
        url.searchParams.delete(k);
      }
    });

    window.history.pushState(null, '', url.toString());

    try {
      const response = await demosAPI.getDemosList(query);
      commit('FETCH_DEMOS_LIST_SUCCESS', { ...response.headers, data: response.data });
    } catch(err) {
      commit('FETCH_DEMOS_LIST_ERROR', err);
    }
  },

  async fetchDemoById({ commit }, { id }){
    commit('FETCH_DEMO_BY_ID_BEGIN');
    try{
      const res = await demosAPI.getDemoById(id);
      commit('FETCH_DEMO_BY_ID_SUCCESS', res.data);
    }catch(err){
      commit('FETCH_DEMO_BY_ID_ERROR', err);
    }
  },

  updateDemosListConfigFilters({commit, dispatch}, payload) {
    commit('UPDATE_DEMOS_LIST_CONFIG_FILTERS', payload);
    dispatch('fetchDemosList');
  },

  updateDemosListConfigPagination({commit, dispatch}, payload) {
    commit('UPDATE_DEMOS_LIST_CONFIG_PAGINATION', payload);
    dispatch('fetchDemosList');
  }
};

const getters = {
  getDemosListConfig: state => state.demosListConfig,
  
  getDemosList: state => state.demosList,
  getFetchDemosListLoading: state => state.fetchDemosListLoading,
  getFetchDemosListError: state => state.fetchDemosListError,
  getFetchDemosListErrorResponse : state => state.fetchDemosListErrorResponse,

  getDemoProduct: state => state.demoProduct,
  getDemoByIdLoading: state => state.fetchDemoByIdLoading,
  getDemoByIdError: state => state.fetchDemoByIdError,
  getDemoByIdErrorResponse: state => state.fetchDemoByIdErrorResponse
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
